import {Occupancy} from "@variocube/app-api";

export interface DeliveryOccupancyContent {
    id: string;

    /** This is the parcel number. */
    deliveryId: string;

    carrierDeliveryCode: string;
    carrierRetrievalCode: string;
    recipientPickupCode: string;

    packageReleaseCodeRequired?: boolean;

    isAdhocDelivery?: boolean;

    barCode?: string;

    storedAt?: string;
    releasedAt?: string;

    carrierId?: string;

    sender?: {
        name: string;
        email?: string;
        phone?: string;
    }
}

export interface BackendApiCredentials {
    baseUrl?: string;
    token?: string;
}

export interface Sender {
    name: string;
    email?: string;
    phone?: string;
}

export interface OutboundDelivery {
    barcode: string;
    needSender: boolean;
    carrier: string;
}

export enum FirstMileField {
    Name = "Name",
    Email = "Email",
    Phone = "Phone"
}

export interface FirstMileConfiguration {
    availableFields: FirstMileField[];
    requiredFields: FirstMileField[];
    allContactFieldsRequired: boolean;
    verifyContactData: boolean;
    reopenCountdown: number;
    offerReceipt: boolean;
}

export interface LastMileConfiguration {
    recipientNameRequired: boolean;
    reopenCountdown: number;
    carrierInterfaceShowsDeliveryOption?: boolean;
}

export type Carriers = Record<string, CubeCarrier>;

export enum CubeCarrierState {
    Enabled = "Enabled",
    FirstMileOnly = "FirstMileOnly",
    LastMileOnly = "LastMileOnly",
    Disabled = "Disabled"
}

export interface CubeCarrier {
    accessCode: string;
    fixedAccessCode?: string;
    pin?: string;
    strokeMinWidth?: number;
    strokeMaxWidth?: number;
    signatureOutputFormat?: SignatureOutputFormat;
    firstMile: FirstMileConfiguration;
    lastMile?: LastMileConfiguration;
    messageDialogConfiguration?: MessageDialogConfiguration;
    autoCarrierRetrieval?: boolean;
    state: CubeCarrierState;
}

export interface MessageDialogConfiguration {
    hideCloseButton?: boolean;
    autoCloseTimer?: number;
}

export type SignatureOutputFormat = "Jpg" | "Png" | "JsonPointList" | "PngNonAlpha";

export type ErrorCode = "INVALID_PACKAGE" | "NO_FITTING_BOX_AVAILABLE";

export function getDeliveryOccupancyContent(occupancy: Occupancy) {
    const {content} = occupancy;
    if (content.id && content.deliveryId) {
        return content as DeliveryOccupancyContent;
    }
}

export interface CubeFeatures {
	headless: boolean;
}
